import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { partnerApiService } from '../../services/api';

export const ForbiddenPage: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const [isCheckingAccess, setIsCheckingAccess] = useState(false);

  const handleGoHome = () => {
    navigate('/');
  };

  const handleContactSupport = () => {
    // Здесь можно добавить логику для связи с поддержкой
    // Например, открыть email или чат
    console.log('Связь с поддержкой');
  };

  // Функция для проверки доступности API
  const checkAccess = async () => {
    if (!isAuthenticated) return false;
    
    setIsCheckingAccess(true);
    try {
      // Пытаемся получить профиль - если получили без 403, значит доступ восстановлен
      await partnerApiService.getProfile();
      console.log('Доступ восстановлен, перенаправляем на главную');
      navigate('/');
      return true;
    } catch (error: any) {
      // Если получили 403 - доступ все еще запрещен
      if (error.response?.status === 403) {
        console.log('Доступ все еще запрещен');
        return false;
      }
      // Другие ошибки (например, 401) - тоже считаем что доступ запрещен
      console.log('Доступ запрещен, ошибка:', error.response?.status);
      return false;
    } finally {
      setIsCheckingAccess(false);
    }
  };

  // Проверяем доступ при загрузке страницы
  useEffect(() => {
    if (isAuthenticated) {
      console.log('Проверяем доступ при загрузке страницы 403');
      checkAccess();
    }
  }, [isAuthenticated]);

  // Периодическая проверка доступа каждые 30 секунд
  useEffect(() => {
    if (!isAuthenticated) return;

    const interval = setInterval(() => {
      console.log('Периодическая проверка доступа на странице 403');
      checkAccess();
    }, 30 * 1000); // 30 секунд

    return () => {
      clearInterval(interval);
    };
  }, [isAuthenticated]);

  // Проверка доступа при возвращении на страницу
  useEffect(() => {
    if (!isAuthenticated) return;

    const handleVisibilityChange = () => {
      if (!document.hidden) {
        console.log('Страница стала активной, проверяем доступ');
        checkAccess();
      }
    };

    const handleFocus = () => {
      console.log('Окно получило фокус, проверяем доступ');
      checkAccess();
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('focus', handleFocus);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('focus', handleFocus);
    };
  }, [isAuthenticated]);

  return (
    <div className="fb-screen">
      <div className="fb-icon" aria-hidden>
        <svg viewBox="0 0 24 24" fill="none">
          <path
            d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M12 8H12.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>

      <h1 className="fb-title">Доступ запрещён</h1>
      <p className="fb-code">Ошибка 403</p>

      <p className="fb-lede">
        У вас нет прав для доступа к этой странице или для выполнения этого действия.
        Возможно, тариф истёк или прав доступа недостаточно.
      </p>

      {isCheckingAccess && (
        <p className="fb-checking" role="status">
          <span className="fb-checking-spinner" aria-hidden />
          Проверяем доступ…
        </p>
      )}

      <div className="fb-actions">
        <button type="button" className="m3-btn-filled" onClick={handleGoHome}>
          Вернуться на главную
        </button>
        <button type="button" className="m3-btn-tonal" onClick={checkAccess} disabled={isCheckingAccess}>
          {isCheckingAccess ? 'Проверяем…' : 'Проверить доступ'}
        </button>
        <button type="button" className="m3-btn-outlined" onClick={handleContactSupport}>
          Связаться с поддержкой
        </button>
      </div>

      <div className="fb-hint">
        <h2 className="fb-hint-title">Что можно сделать</h2>
        <ul className="fb-hint-list">
          <li>Проверьте срок действия тарифа</li>
          <li>Убедитесь, что у вас есть права на эту функцию</li>
          <li>Обратитесь к администратору за доступом</li>
          <li>Свяжитесь с технической поддержкой</li>
        </ul>
      </div>
    </div>
  );
};
